import { Skeleton } from "@mui/material";
import { FC } from "react";

const FilterProjectsSkeleton: FC = () => {
  return <Skeleton width={90} height={28} sx={{ transform: 'translateY(0)', borderRadius: '8px', ml: 1, }} />
}

export default FilterProjectsSkeleton;
